export interface ISubActivity {
    activeUntilDate?: Date;
    id: number;
    name: string;
    activityId: number
}

const newSubActivity = (): ISubActivity => ({
    id: 0,
    activityId: 0,
    name: '',
})

export const createSubActivity = <T extends Partial<ISubActivity>>(initialValues: T): ISubActivity & T => {
    return Object.assign(newSubActivity(), initialValues);
};